import type React from 'react';

import { artemyEventApi, EventApiProvider } from '@vlabs/monokit/entities/events/api';
import type { EventListPermissions } from '@vlabs/monokit/entities/events/event-list-table';
import {
  EventListFastFilters,
  EventListFilterMenu,
} from '@vlabs/monokit/entities/events/filters';
import { useHasPermission, usePageAccess } from '@vlabs/permissions';
import { useLocation } from 'react-router-dom';

import { EventListPageView } from './EventListPageView';
import { EventListViewer } from './EventListViewer';

interface EventListPagePoint3Props {
  includedAttributes?: string[];
}

function EventListPagePoint3({
  includedAttributes = [],
}: EventListPagePoint3Props): React.JSX.Element {
  const { search } = useLocation();
  const topSimilarObjectId = new URLSearchParams(search).get('top_similar_object_ids');
  const permissions: EventListPermissions = {
    canViewEventDetails: usePageAccess('event_fs_details'),
    canReadCard: useHasPermission('card', 'read'),
    canViewCardDetails: usePageAccess('cards_details'),
    canReadHandler: useHasPermission('handler', 'read'),
    canViewHandlersPage: usePageAccess('handlers'),
    canReadStream: useHasPermission('stream', 'read'),
    canViewStreamWatch: usePageAccess('streams_fs'),
    canViewStreamDetails: usePageAccess('stream_details'),
    canReadList: useHasPermission('list', 'read'),
    canViewListDetails: usePageAccess('lists'),
  };

  return (
    <EventApiProvider api={artemyEventApi}>
      <EventListPageView
        fastFilters={EventListFastFilters}
        filterMenu={EventListFilterMenu}
        includedAttributes={includedAttributes}
        initialFilters={topSimilarObjectId ? { top_similar_object_ids: [topSimilarObjectId] } : undefined}
        key={topSimilarObjectId ?? 'default'}
        permissions={permissions}
        viewer={EventListViewer}
      />
    </EventApiProvider>
  );
}

export { EventListPagePoint3 };
